// extracted by mini-css-extract-plugin
export var closeButton = "_q6-2";
export var closeButtonIcon = "_q6-3";
export var lightboxContent = "_q6-1";
export var lightboxOverlay = "_q6-0";